const $ = jQuery

function loadMoreProducts (CURRENT_URL) {
  const WRAPPERS = document.querySelectorAll('.mtt-product-link-boxes')

  for (let i = 0; i < WRAPPERS.length; i++) {
    const WRAPPER = WRAPPERS[i]
    new LoadMoreProductsAjax(WRAPPER, CURRENT_URL)
  }
}

class LoadMoreProductsAjax {
  constructor (WRAPPER, CURRENT_URL) {
    this.WRAPPER = WRAPPER
    this.GRID_WRAPPER = this.WRAPPER.querySelector('.mtt-product-link-boxes__grid')
    this.LOAD_MORE_BUTTON = this.WRAPPER.querySelector('.mtt-product-link-boxes__show-more button')
    this.CURRENT_URL = CURRENT_URL

    if (this.LOAD_MORE_BUTTON) {
      this.addLoadMore()
    }
  }

  addLoadMore () {
    this.PRODUCTS_ARRAY = this.WRAPPER.querySelector('[data-array]').getAttribute('data-array')
    this.CARD_TYPE = this.WRAPPER.querySelector('[data-card-type]').getAttribute('data-card-type')

    this.LOAD_MORE_BUTTON.addEventListener('click', () => {
      this.CURRENT_PAGE = parseInt(this.LOAD_MORE_BUTTON.getAttribute('data-page'))
      this.WRAPPER.classList.add('loading')

      $.ajax({
        type: 'POST',
        url: main_theme_objects.ajax_url,
        data: {
          action: 'products_load_more',
          page: this.CURRENT_PAGE + 1,
          products: JSON.parse(this.PRODUCTS_ARRAY),
          card_type: this.CARD_TYPE
        },
        success: (result) => {
          this.LOAD_MORE_BUTTON.setAttribute('data-page', this.CURRENT_PAGE + 1)

          $(this.GRID_WRAPPER).append(result.markup)

          this.WRAPPER.querySelector('.current-index').innerHTML = result.product_count

          if (result.isEmpty) {
            this.LOAD_MORE_BUTTON.classList.add('disabled')
          }

          this.WRAPPER.classList.remove('loading')
          this.setParams(this.CURRENT_PAGE + 1)
          this.setProgressBarWidth(result.product_count)
        }
      })
    })
  }

  setParams (PAGE) {
    const url = this.CURRENT_URL
    url.searchParams.set('pa', PAGE)
    window.history.replaceState(null, null, url)
  }

  setProgressBarWidth (PAGE) {
    const LINE = this.WRAPPER.querySelector('.mtt-product-link-boxes__progress-bar .line')
    LINE.style.width = (PAGE / JSON.parse(this.PRODUCTS_ARRAY).length) * 100 + '%'
  }
}

export default loadMoreProducts